// extracted by mini-css-extract-plugin
export default {"menuList":"xvjOA9Y6yvCCkyjTs7YI","menuListWithRoundedCorners":"bvNBNKkMwjII4VYcVxF2"};